import { render, staticRenderFns } from "./NewCampaignArticle.vue?vue&type=template&id=e5c8207c&scoped=true&"
import script from "./NewCampaignArticle.vue?vue&type=script&lang=ts&"
export * from "./NewCampaignArticle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c8207c",
  null
  
)

export default component.exports